import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Button } from "reactstrap";

export const ExportToExcel = ({ apiData,HeaderHead,Header, topHeader, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, HeaderHead,Header, topHeader, fileName) => {
    const ws = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(ws, topHeader.map((h) => [h]) );
    XLSX.utils.sheet_add_aoa(ws, [HeaderHead,], {
        origin: "A" + (topHeader.length + 1),
        skipHeader: false,
      });
      XLSX.utils.sheet_add_aoa(ws, [Header,] , {
        origin: "A" + (topHeader.length + 2),
        skipHeader: false,
      })
      XLSX.utils.sheet_add_aoa(ws, apiData , {
        origin: "A" + (topHeader.length + 3),
        skipHeader: false,
      })
 
    var headerWith = 6;

    var merges = topHeader.map((h, i) => {
      return { s: { r: i, c: 0 }, e: { r: i, c: headerWith } };
    });
    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"] = merges;

    // XLSX.utils.sheet_add_json(ws, apiData, {
    //   origin: "A" + (topHeader.length + 1),
    //   skipHeader: false,
    // });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button
      type="button"
      outline
      color="secondary"
      onClick={(e) => exportToCSV(apiData, HeaderHead,Header, topHeader, fileName)}
    >
      <i className="ri-file-excel-2-line"></i>
      <span className="d-none d-inline-block ml-1">Excel</span>
    </Button>
  );
};
